import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _Lightning = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                strokeMiterlimit: 1.414,
                strokeWidth: props.strokeWidth || 1.5,
                d: "m11.9735 1.8672-7.743 12.7531c-.101.1666.0188.3797.2138.3797h7.0557l-.44 7.0407c-.0161.2572.3204.3676.4598.1508l8.2326-12.8063c.1069-.1664-.0125-.3852-.2103-.3852h-7.5421l.4367-6.9875c.0163-.2607-.3277-.3686-.4632-.1453Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: 2,
                d: "M12 21v.0001",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const Lightning = addPropsToSVG(_Lightning);

export { Lightning };
